module.exports = __webpack_public_path__ + "img/21.2be61157.png";